import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-paging@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  orderById: 20,
  elementType: 'PageBox',
  elementDesc: '分页符',
  type: 'pagebox',
  pageSize: 1,
  pageTotal: 1,
  toolbar: {
    edit: true,
    delete: true,
    copy: false,
    config: false
  },
  isRequired: '1',
  config: true,
  placeholder: '分页符',
  value: '',
  saveUrl: '/design/qu-pagetag/ajaxSave.do',
  iconStyle: {
    width: '12px',
    height: '12px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      pageSize: this.pageSize,
      pageTotal: this.pageTotal
    }, this)
  },
  saveCb (data) {
    this.pageSize = data.pageSize || 1
    this.pageTotal = data.pageTotal || 1
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/PageBox/config.js